import React, { useEffect, useState, useContext, useCallback } from 'react';
import AuthContext from '../services/AuthContext';
import axiosInstance from '../services/axiosInstance';
import BacReviewPopup from './BacReviewPopup';
import { useToast } from '@chakra-ui/react';

export default function BacReviewCheck() {
    const { user } = useContext(AuthContext);
    const [isOpen, setIsOpen] = useState(false);
    const [isEligible, setIsEligible] = useState(false);
    const toast = useToast();

    const checkEligibility = useCallback(async () => {
        if (!user || user.role !== 'student') {
            return;
        }

        try {
            const response = await axiosInstance.get('/users/bac-review-eligibility');
            if (response.data.success && response.data.isEligible) {
                setIsEligible(true);
                setIsOpen(true);
            }
        } catch (error) {
            console.error('Error checking Bac Review eligibility:', error);
        }
    }, [user]);

    useEffect(() => {
        // Trigger check shortly after mount to ensure smooth loading and token availability
        const timer = setTimeout(checkEligibility, 2500);
        return () => clearTimeout(timer);
    }, [checkEligibility]);

    const handleAction = async (status) => {
        try {
            const response = await axiosInstance.put('/users/bac-review-status', { status });
            if (response.data.success) {
                setIsOpen(false);
                if (status === 'registered') {
                    toast({
                        title: "تم التسجيل بنجاح",
                        description: "سنتصل بك قريباً لتأكيد تفاصيل المراجعة.",
                        status: "success",
                        duration: 5000,
                        isClosable: true,
                    });
                }
            }
        } catch (error) {
            console.error('Error updating Bac Review status:', error);
            toast({
                title: "خطأ",
                description: "حدث خطأ أثناء معالجة طلبك.",
                status: "error",
                duration: 5000,
                isClosable: true,
            });
        }
    };

    if (!isEligible) return null;

    return (
        <BacReviewPopup 
            isOpen={isOpen} 
            onClose={() => handleAction('declined')}
            onInscrire={() => handleAction('registered')}
        />
    );
}
